import React from 'react';
import * as actionTypes from "@redux/actionTypes";
import { useDispatch, useSelector } from "react-redux";
import { LiceneceInventroyIcon, ItemInventoryIcon } from '@util/svgicon';
import { useRouter } from 'next/router';

const LeftSection = ({ nftColletion }) => {
    const router = useRouter();
    const dispatch = useDispatch();
    const coinInputNumberDefault = useSelector((state) => state.coinName.coinInputNumberDefault);

    const buyTcHandler = () => {
        dispatch({
            type: actionTypes.BUY_TC,
            payload: true,
        });
        dispatch({
            type: actionTypes.COIN_BALANCE_NUMBER,
            payload: coinInputNumberDefault,
        });
    };

    const buyLpHandler = () => {
        router.push('/buy-gamepass');
    }

    return (
        <div className='w-full h-full flex p-[32px] flex-col justify-between items-center'>
            <div className='flex flex-col items-start gap-[16px]'>
                <p className='text-[#FAFAFA] text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px] opacity-50'>Your inventory!</p>
                {/* <div className='flex items-center gap-[8px]'>
                    <LiceneceInventroyIcon />
                    <p className='text-[#FFF] text-[42px] not-italic font-semibold leading-[42px] tracking-[-2.52px]'>1</p>
                    <p className='text-[#FFF] text-[20px] not-italic font-semibold leading-[24px] tracking-[-1.2px]'>License</p>
                </div> */}
                <div className='flex items-center gap-[8px]'>
                    <ItemInventoryIcon />
                    <p className='text-[#FFF] text-[42px] not-italic font-semibold leading-[42px] tracking-[-2.52px]'>{nftColletion.length}</p>
                    <p className='text-[#FFF] text-[20px] not-italic font-semibold leading-[24px] tracking-[-1.2px]'>Items</p>
                </div>
                <p className='text-[#FAFAFA] text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>
                    Your inventory contains collectibles you've picked up during missions or drives on your personal EarthRover.
                </p>
                {/* <p className='text-[#FAFAFA] text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>
                    Collectibles can be found during missions and can unlock achievements and more for you. Click below to get started with a pass or a mission!
                </p> */}
            </div>
            <div className='flex flex-col items-start gap-[16px] self-stretch'>
                {/* <button className='flex w-full h-[56px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[32px] bg-[#25BD66]' onClick={buyLpHandler}>
                    <p className='text-[#FAFAFA] text-[20px] not-italic font-semibold leading-[20px] tracking-[-0.8px]'>
                        Purchase More LP
                    </p>
                </button>
                <button className='flex w-full h-[56px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[32px] bg-[#25BD66]' onClick={buyTcHandler}>
                    <p className='text-[#FAFAFA] text-[20px] not-italic font-semibold leading-[20px] tracking-[-0.8px]'>
                        Purchase TC
                    </p>
                </button> */}
                <button className='flex w-full h-[56px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[32px] bg-[#000]' onClick={() => { window.open(`https://shop.frodobots.com/`) }}>
                    <p className='text-[#FAFAFA] text-[20px] not-italic font-semibold leading-[20px] tracking-[-0.8px]'>
                        Buy an EarthRover
                    </p>
                </button>
            </div>
        </div>
    )
}

export default LeftSection